import * as React from 'react';
import { GeoSuggestionField } from '../../components/GeoSuggestionField';
import { useGeoSuggest } from './utils/useGeoSuggest';
import { useValidateAddress } from './utils/useValidateAddress';
import { useOnBlur } from './utils/useOnBlur';
import { useOnValueChange } from './utils/useOnValueChange';
import { useOnItemClick } from './utils/useOnItemClick';
import { TAddressValue } from './types';
import { IBaseQuestionProps, TAnswersState } from '../FormContainer/types/internal';
import { path } from 'ramda';
import { QuestionLayoutContainer } from '../QuestionLayoutContainer';
import { useFormTracking } from '../../utils/useFormTracking';

export const AddressSuggestContainer: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = props => {
  const {
    question: { answerField, required, title, placeholder },
    setAnswersState,
    answersState,
    setNextStep,
  } = props;

  const formValue = path<TAddressValue>([answerField, 'value'], answersState);
  const [suggestValue, setSuggestValue] = React.useState(formValue?.address || '');
  const [houseId, setHouseId] = React.useState<number | null>(formValue?.houseId || null);
  const [locationId, setLocationId] = React.useState<number | null>(formValue?.locationId || null);

  const { trackSubmit } = useFormTracking();
  const { isFetching: suggestLoading, suggestError, suggestData, getSuggestions } = useGeoSuggest();
  const isNextBtnDisabled = required && !houseId;
  const {
    isFetching: validateLoading,

    validateError,
    resetValidation,
    validateAddress,
  } = useValidateAddress({ onHouseIdChange: setHouseId, onLocationIdChange: setLocationId });

  const onValueChange = useOnValueChange({ getSuggestions, setSuggestValue, resetValidation });
  const onItemClick = useOnItemClick({ setSuggestValue, validateAddress });
  const onBlur = useOnBlur({ validateAddress, suggestValue });
  const onSubmit = () =>
    setAnswersState(prevState => {
      const nextAnswersState: TAnswersState = {
        ...prevState,
        [answerField]: {
          answerField,
          value: {
            address: suggestValue,
            houseId,
            locationId,
          },
        },
      };
      setNextStep(nextAnswersState);
      trackSubmit({
        value: formValue && formValue.address,
        isRequired: true,
        field: answerField,
      });

      return nextAnswersState;
    });

  return (
    <QuestionLayoutContainer title={title} onSubmit={onSubmit} disableSubmit={isNextBtnDisabled}>
      <GeoSuggestionField
        value={suggestValue}
        suggestData={suggestData}
        suggestError={suggestError}
        errorMessage={validateError}
        isLoading={suggestLoading || validateLoading}
        onItemClick={onItemClick}
        onValueChange={onValueChange}
        placeholder={placeholder || 'Населенный пункт, улица, дом'}
        onBlur={onBlur}
        inputName={answerField}
      />
    </QuestionLayoutContainer>
  );
};

AddressSuggestContainer.displayName = 'AddressSuggestContainer';
